import { Dialog } from "primereact/dialog";
import useRecordActionModal from "./useRecordActionModal";
import styles from "../../style.module.scss"

const RecordActionModal = (props) => {
    const { catalogForm, submitHandler, handleClose, header, footer } = useRecordActionModal(props);

    return (
        <Dialog className={styles.actionModal} header={header}
                footer={footer}
                visible={props.isVisible}
                onHide={handleClose}
                headerStyle={{ padding: "16px 16px 8px" }}
                contentStyle={{ padding: "8px 16px 16px" }}
                pt={{
                    footer: {
                        style: {
                            padding: "16px 4px 16px 16px",
                            backgroundColor: "#F9FAFB",
                        },
                    },
                }}
        >
            <form onSubmit={submitHandler}>
                {catalogForm}
            </form>
        </Dialog>
    );
};

export default RecordActionModal;